<template>
  <v-layout row class="mt-2 ml-2">
    <v-flex xs2>
      <div tooltip="Biens vus" class="d-flex align-items-center">
        <v-icon>visibility</v-icon>
        <span class="insight">{{
          project ? project.reportingCount || 0 : "..."
        }}</span>
      </div>
    </v-flex>

    <v-flex xs2>
      <div tooltip="Biens proposés" class="d-flex align-items-center">
        <v-icon>list</v-icon>
        <span class="insight">{{ proposals ? proposals.length : "..." }}</span>
      </div>
    </v-flex>
    <v-flex xs2>
      <div tooltip="Biens aimés" class="d-flex align-items-center">
        <v-icon>thumb_up</v-icon>
        <span class="insight">{{
          likedProposals ? likedProposals.length : "..."
        }}</span>
      </div>
    </v-flex>
    <v-flex xs2>
      <div tooltip="Biens pas aimés" class="d-flex align-items-center">
        <v-icon>thumb_down</v-icon>
        <span class="insight">{{
          dislikedProposals ? dislikedProposals.length : "..."
        }}</span>
      </div>
    </v-flex>
    <v-flex xs2>
      <div tooltip="Visites planifiées" class="d-flex align-items-center">
        <v-icon>event</v-icon>
        <span class="insight">{{
          proposalsWithVisits ? proposalsWithVisits.length : "..."
        }}</span>
      </div>
    </v-flex>
    <v-flex xs2 class="d-flex d-flex-initial justify-end pr-3">
      <v-icon color="accent" @click="$emit('hideFloatingWindows')"
        >close</v-icon
      >
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
  name: "ProjectStats",
  computed: {
    ...mapGetters("projects", [
      "likedProposals",
      "dislikedProposals",
      "proposalsWithVisits"
    ]),
    ...mapState("projects", {
      project: state => state.current,
      proposals: state => state.proposals,
      proposalsLoaded: state => state.proposalsLoaded
    })
  }
};
</script>

<style scoped></style>
